module.exports = __webpack_public_path__ + "assets/img/block-hover-bb49ac68.png";